export default{"@@functional/placeholder":!0};
